// eslint-disable-next-line import/no-extraneous-dependencies
import Node from '@ckeditor/ckeditor5-engine/src/model/node';
import { useDroppable } from '@dnd-kit/core';
import { useId } from 'react';

interface DroppableProps {
  node: Node;
  position: 'before' | 'end';
  draggingNode: Node | null;
}

export function Droppable({ node, position, draggingNode }: DroppableProps) {
  const id = useId();
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: {
      node,
      position,
    },
  });

  return (
    draggingNode && (
      <div ref={setNodeRef} style={{ position: 'relative' }} className={isOver ? `droppable drop-over` : `droppable`}>
        <div className="droppable-indicator" />
      </div>
    )
  );
}
